import * as React from 'react';

const StarFilled16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.97.5c-.3 0-.57.19-.66.47L5.754 5.5H.659C.3 5.5 0 5.8 0 6.16c0 .21.1.41.28.54l4.085 2.9-1.768 5.13a.58.58 0 0 0 .889.66L8 12.18l4.514 3.21a.58.58 0 0 0 .889-.66L11.636 9.6l4.084-2.9c.17-.12.28-.32.28-.54 0-.36-.3-.66-.66-.66h-5.113L8.65.97A.7.7 0 0 0 7.99.5h-.02Z"
  }
));
StarFilled16.Size = 16;
StarFilled16.Title = "StarFilled";

export { StarFilled16 as default };
